import { createSingularDay } from '@ebalance/proto/bffuser/v1/singular_day_service-SingularDayService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'
import { singularDayQueryKeys } from '~/pages/AdminSingularDay/hooks/queryKeys'

/**
 * 特異日新規登録 mutation hook (AC-03 / AC-11: tombstone 復活も同じ RPC で
 * 行う)。 onSuccess で list query を invalidate してカレンダーを最新化する。
 */
export function useCreateSingularDay(): InvalidatingMutationResultFor<
  typeof createSingularDay
> {
  return useInvalidatingMutation(createSingularDay, [singularDayQueryKeys.list])
}
